import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

import {
  YYYY_MM_DD_FORMAT,
  YYYY_MM_DD_HH_MM_FORMAT,
  HH_MM_FORMAT,
  DDDD_MMMM_YYYY_FORMAT,
} from "../../settings/constants";

interface ActivityItemProps {
  date: string;
  activities: any[];
}

const useStyles = makeStyles((theme) => ({
  date: {
    fontSize: 12,
    color: theme.palette.grey[500],
    marginBottom: 15,
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 40,
    marginRight: 10,
  },
  concerned: {
    fontSize: 14,
    fontWeight: "bold",
    marginRight: 5,
  },
  action: {
    fontSize: 14,
  },
  hour: {
    fontSize: 12,
    color: theme.palette.grey[500],
    marginBottom: 15,
    marginLeft: 34,
  },
}));

export const ActivityItem = (props: ActivityItemProps) => {
  const classes = useStyles();

  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <Typography className={classes.date} variant="h4" component="h4">
          {moment(props.date, YYYY_MM_DD_FORMAT).format(DDDD_MMMM_YYYY_FORMAT)}
        </Typography>
      </Grid>
      {props.activities.map((entry) => (
        <Grid container item xs={12}>
          <Grid container direction="row" alignItems="center" item xs={12}>
            <img
              className={classes.avatar}
              alt="avatar"
              src={entry.avatar ?? process.env.PUBLIC_URL + "/user_avatar.png"}
            />
            <Typography
              className={classes.concerned}
              variant="h4"
              component="h4"
            >
              {entry.concerned}
            </Typography>
            <Typography className={classes.action} variant="h4" component="h4">
              {entry.action}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.hour} variant="h4" component="h4">
              {moment(entry.date, YYYY_MM_DD_HH_MM_FORMAT).format(HH_MM_FORMAT)}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
